import React, {
  type DetailedHTMLProps,
  forwardRef,
  type HTMLAttributes,
  useMemo,
  useRef,
} from 'react';
import classNames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import useCombinedRefs from '@hooks/useCombinedRefs';

interface Props
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  isOpen: boolean;
}

const DropdownMenu = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { isOpen, className, children, ...rest } = props;
  const innerRef = useRef<HTMLDivElement>(null);
  const combinedRef = useCombinedRefs<HTMLDivElement>(ref, innerRef);

  const pos = useMemo(() => {
    if (!innerRef.current) return 'top-35';
    const { bottom } = innerRef.current.getBoundingClientRect();
    if (window.innerHeight - bottom < 400) return 'bottom-35';
    return 'top-35';
  }, [isOpen]);

  return (
    <div
      className={classNames(
        'absolute z-30 mt-5 w-full select-none overflow-hidden rounded bg-white text-black focus:outline-none',
        pos,
        className
      )}
      {...rest}
      ref={combinedRef}
    >
      {isOpen && (
        <Scrollbars autoHeight autoHeightMax={375}>
          {children}
        </Scrollbars>
      )}
    </div>
  );
});

export default DropdownMenu;
